export const MIN_AGE = 21;
